module.exports = __webpack_public_path__ + "img/2f_r_koichiro.61e68422.png";